module.exports = __webpack_public_path__ + "static/media/img5.fc99d9b3.jpg";